module.exports = __webpack_public_path__ + "static/media/free-cancellation.8134544e.svg";